export const VERT = 'vert'
export const FRAG = 'frag'
export const COMMON = 'common'
export const DEFAULT_VERT_CHUNK = 'project_vertex'
export const DEFAULT_FRAG_CHUNK = 'dithering_fragment'
